import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import Subheader from "@components/Subheader/Subheader";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Deficiencies } from "./grid/Deficiencies";

const TEST_ID_BASE = "deficiencies-page";

const DeficienciesContainer: React.FC = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const { userActionPermissions } = useAuthStore();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  const canRequestFottDeficiency = checkPermission(
    userActionPermissions,
    "canRequestFottDeficiency",
  );

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={t("deficiencies.subtitle")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t("deficiencies.title")}</span>
            {canRequestFottDeficiency && (
              <Button
                type="button"
                variant="contained"
                color="primary"
                testId={`${TEST_ID_BASE}-create-button`}
                label={
                  <span className="text-sm font-medium flex items-center gap-2">
                    <AddCircleOutlineIcon fontSize="small" />
                    {t("deficiencies.add-deficiency")}
                  </span>
                }
                sx={{ textTransform: "none", height: "40px", minHeight: "40px" }}
                onClick={() =>
                  navigate(`/${paths.deficiencies.index}/${paths.deficiencies.create}`)
                }
              />
            )}
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        <Deficiencies />
      </div>
    </PageLayout>
  );
};

export default DeficienciesContainer;
